module.exports = __webpack_public_path__ + "img/marker_group_small.eb2df052.svg";